// Posts that render as full-viewport app pages (dark studio chrome).
// Used by gatsby-ssr (initial paint) and gatsby-browser (client navigation);
// the styling lives under `body.app-page` in style.css.
export const APP_PAGES = [
  "/surface-plotter/",
  "/surface-gallery/",
  "/piecewise-isometries-3d/",
]

export const isAppPage = pathname => {
  if (!pathname) return false
  const normalized = pathname.endsWith("/") ? pathname : `${pathname}/`
  return APP_PAGES.includes(normalized)
}
